<template>
  <div>
    <h1>Neues Team anlegen</h1>

    <form class="w-full max-w-sm m-10">
      <div class="flex items-center border-b border-b-2 border-teal py-2">
        <input
          id="team-name"
          v-model="teamName"
          class="appearance-none bg-transparent border-none w-full text-grey-darker mr-3 py-1 px-2 leading-tight focus:outline-none"
          type="text"
          placeholder="Team Name"
          aria-label="Team Name"
        >
      </div>
      <p class="text-grey-dark text-xs italic mt-2">
        Angezeiter Name
      </p>

      <div class="flex items-center border-b border-b-2 border-teal py-2 mt-12">
        <input
          id="team-key"
          v-model="shortKey"
          class="appearance-none bg-transparent border-none w-full text-grey-darker mr-3 py-1 px-2 leading-tight focus:outline-none"
          type="text"
          placeholder="Kürzel"
          aria-label="Kurztext"
        >
      </div>
      <p class="text-grey-dark text-xs italic mt-2">
        Abkürzung des Teamnamens. Z.bsp. für links
      </p>

      <div class="mt-12">
        <label
          class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
          for="grid-first-name"
        >
          Jugend
        </label>
        <div class="inline-block relative w-32">
          <select
            id="grid-first-name"
            v-model="selectedYouth"
            class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          >
            <option
              v-for="youth in aviableYouths"
              :key="youth.key"
            >
              {{ youth.key }}
            </option>
          </select>
          <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            ><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
          </div>
        </div>

        <p class="text-grey-dark text-xs italic mt-2">
          Beeinflusst die zur verfügungstehenden Übungen
        </p>
      </div>

      <div class="mt-8 mb-8">
        <pv-button
          label="Anlegen"
          icon="pi pi-check"
          autofocus
          @click="save()"
        />

        <pv-button
          label="Abbrechen"
          icon="pi pi-times"
          class="p-button-text"
          @click="$router.back()"

        />

      </div>
    </form>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'TeamCreate',
    data () {
        return {
            teamName: '',
            shortKey: '',
            selectedYouth: null,
            aviableYouths: null,
            imagePath: ''
        }
    },
    async mounted () {
        await this.loadYouths()
    },
    methods: {
        async save () {
            await apiService.createTeam(this.teamName, this.shortKey, this.selectedYouth)
            await this.$router.push({ name: 'team.created' })
        },
        async loadYouths () {
            const response = await apiService.getYouths()
            this.aviableYouths = response.data
        },
        onSelected: function (youth) {
        }
    }
}
</script>

<style scoped>

</style>
